import Pagination from '@material-ui/lab/Pagination';
import { Form, Input, message } from 'antd';
import _ from 'lodash';
// import moment from "moment";
import React, { Suspense, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
// import CustomButton from '../../../components/CustomButton';
import { actionDeleteTextFooter, actionGetListCategorySEO } from '../../../redux/post/actions';
import { useSubheader } from "../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader
} from "../../../_metronic/_partials/controls";
import ActionEditDelete from '../../../components/ActionEditDelete';
import CreateUpdateCategorySEO from './CreateUpdateCategorySEO';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const formRef = React.createRef()

function ListCategorySEO(props) {
    const suhbeader = useSubheader();
    const [visibleSearch, setVisibleSearch] = useState(false)
    const [visibleModal, setVisibleModal] = useState(false)
    const [recordModal, setRecordModal] = useState(null)
    const [filterModal, setFilterModal] = useState(null)
    const history = useHistory()
    const { intl } = props
    suhbeader.setTitle(intl.formatMessage({ id: 'SIDEBAR.CATEGORY_SEO' }));
    const dispatch = useDispatch();
    const { dataCategorySEO } = useSelector(state =>
    ({  
        dataCategorySEO: state.postReducer.dataCategorySEO,
    })
        , shallowEqual)

    useEffect(() => {
        dispatch(actionGetListCategorySEO({ page: 1, limit: 15 }));
    }, [dispatch])

    const onChangePage = async (_, page) => {
        let { title } = formRef.current.getFieldsValue()
        await dispatch(actionGetListCategorySEO({ page, title: title ? title.trim() : '' }));
    }

    const onSearchDelayed = _.debounce(() => onSearch(), 100)
    const onSearch = async () => {
        let { title, gender, status, department } = formRef.current.getFieldsValue()
        setVisibleSearch(true)
        await dispatch(actionGetListCategorySEO({ page: 1, limit: 15, title: title ? title.trim() : '' }));
    }

    const onDelete = async (id) => {
        if (window.confirm("Bạn có muốn xóa?")) {
            const res = await dispatch(actionDeleteTextFooter({
                id,
                filterModal: {
                    page: dataCategorySEO?.paging?.page,
                    limit: 15,
                }
            }));
            if (res) {
                message.success("Xóa thành công")
            }
        }
    }

    const enterKeyPressed = (event) => {
        if (event.keyCode === 13) {
            onSearch()
        }
    }

    const renderBodyTable = () => {
        return dataCategorySEO?.rows?.length > 0
            ? dataCategorySEO.rows.map((it, idx) => {
                return (
                    <tr key={`renderBodyTable_${it.id || idx}`}>
                        <td className="tr-center">
                            {(dataCategorySEO?.paging?.page - 1) * dataCategorySEO?.paging?.limit + idx + 1}
                        </td>
                        <td className="tr-left">
                            {it?.title || "--"}
                        </td>
                        <td className="tr-left">
                            {it?.title_seo || ''}
                        </td>

                        <td className="tr-center">
                            <ActionEditDelete
                                tooltipText=""
                                onclickView={() => onOpenModal(it)}
                                // onclickPreviewView={() => onclickPreviewView(it)}
                                onclickDelete={() => onDelete(it.id)}
                                hideEdit={true}
                                hideDelete
                            />
                        </td>
                    </tr>
                )
            })
            : <tr>
                <td className="tr-center" colSpan={12}>Không có dữ liệu hiển thị</td>
            </tr>
    }

    const onCloseModal = () => {
        setRecordModal(null)
        setFilterModal(null)
        setVisibleModal(false)
    }
    console.log(dataCategorySEO?.rows?.filter((e) => e.del !== 1)?.map((elm) => elm?.url), 'rows=====================');
    console.log(dataCategorySEO?.list?.map((e) => e.url), 'list=====================');

    // const rowsFilteredUrls = dataCategorySEO.rows.filter((e) => e.del !== 1).map((elm) => elm.url);
    // const listUrls = dataCategorySEO.list.map((e) => e.url);

    // const uniqueInRows = rowsFilteredUrls.filter(url => !listUrls.includes(url));
    // const uniqueInList = listUrls.filter(url => !rowsFilteredUrls.includes(url));

    // if (uniqueInRows.length === 0 && uniqueInList.length === 0) {
    //     console.log('Hai mảng chứa các phần tử giống nhau');
    // } else {
    //     console.log('Các phần tử khác nhau:');
    //     if (uniqueInRows.length > 0) {
    //         console.log('Có trong rows nhưng không có trong list:', uniqueInRows);
    //     }
    //     if (uniqueInList.length > 0) {
    //         console.log('Có trong list nhưng không có trong rows:', uniqueInList);
    //     }
    // }
    const onOpenModal = (dataEdit) => {
        // if (!dataEdit)
        //     setRecordModal(null)
        // else
        //     setRecordModal(dataEdit)

        // setFilterModal({
        //     page: dataCategorySEO?.paging?.page
        // })
        if (!dataEdit)
            // if (uniqueInList.length > 0) {
                history.push("/category-seo/0");
            // } else {
            //     message.error('Tất cả danh mục đã có nội dung')
            // }
        else
            history.push(`/category-seo/${dataEdit.id}`);
        setVisibleModal(true)
    }

    const onClearSearch = async () => {
        formRef.current.setFieldsValue({ title: undefined })
        setVisibleSearch(false)
        await dispatch(actionGetListCategorySEO({ page: 1, limit: 15 }));
    }

    return (
        <>
            <Card>
                <CardHeader title={intl.formatMessage({ id: 'SIDEBAR.CATEGORY_SEO' })}>
                </CardHeader>
                <CardBody>
                    <Form
                        className="width100"
                        ref={formRef}
                    >
                        {/* <div className="layout-form-header row">
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Tên danh mục{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="title"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập tên danh mục"
                                    />
                                </Form.Item>
                            </div>
                        </div> */}
                        {/* <div className="mb--20 row-end">
                            <CustomButton
                                className="mr--10"
                                title="Tìm kiếm"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onSearchDelayed}
                            />
                            {visibleSearch && <CustomButton
                                className="customClearSearch mr--10"
                                title="Bỏ lọc"
                                btnBgColor="#eceef7"
                                btnColor="#192038"
                                btnHoverBackground="#eceef7"
                                onClick={onClearSearch}
                            />}
                            <CustomButton
                                title="Thêm mới"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onOpenModal}
                            />

                        </div> */}
                        <div className="trongCustomTableCtn2">
                            <table className="customTable">
                                <tr className="bg-E6F8FD">
                                    <th className="tr-center">STT</th>
                                    <th className="tr-left">Tên danh mục</th>
                                    <th className="tr-left">Tiêu đề SEO</th>
                                    <th className="tr-center">Thao tác</th>
                                </tr>
                                {renderBodyTable()}
                            </table>
                        </div>
                        <div className="mt--20 rowx-center">
                            {dataCategorySEO?.paging?.total > dataCategorySEO?.paging?.limit && <div className="mt--20 rowx-center">
                                <Pagination
                                    count={dataCategorySEO?.paging?.count} //total
                                    page={dataCategorySEO?.paging?.page} //current page
                                    variant="outlined" shape="rounded" showFirstButton showLastButton
                                    onChange={(event, page) => onChangePage(event, page)}
                                />
                            </div>}
                        </div>
                    </Form>
                </CardBody>
            </Card>
            <Suspense fallback={<div></div>}>
                <section>
                    {visibleModal && <CreateUpdateCategorySEO
                        onCloseModal={onCloseModal}
                        visibleModal={visibleModal}
                        recordModal={recordModal}
                        filterModal={filterModal}
                        listCategorySEO={dataCategorySEO?.list}
                    />}
                </section>
            </Suspense>
        </>
    );
};
export default injectIntl(withRouter(ListCategorySEO));